/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {AssuredWorkloadOutlined, DashboardOutlined, SupportAgentOutlined} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Inicio from "./Secciones/Seccion_Inicio";
import Seccion_Retiros from "./Secciones/Seccion_Retiros";
import Seccion_Soporte from "./Secciones/Seccion_Soporte";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >

            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', p: 4}}>
                <Typography sx={{right: 12, bottom: 8}}>v 0.1.3</Typography>
            </Grid>

        </Grid>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Inicio',
        icono: DashboardOutlined,
        camino: '/Inicio',
        categoria: 'Personal',
        Componente: <Seccion_Inicio/>
    },
    {
        nombre: 'Retiros',
        icono: AssuredWorkloadOutlined,
        camino: '/Retiros',
        categoria: 'Personal',
        Componente: <Seccion_Retiros/>
    },
    {
        nombre: 'Soporte',
        icono: SupportAgentOutlined,
        camino: '/Soporte',
        categoria: 'Soporte',
        Componente: <Seccion_Soporte/>
    },
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}